import type { ResourceLanguage } from "i18next";

import { Tk } from "../translation-key";
import { pluralForSlavic, tk } from "../utils";

const RESOURCES = {
  translation: {
    EN: "angl",
    UK: "ukr",
    DE: "nem",
    SK: "slov",
    RU: "rus",
    ENGLISH: "anglický",
    UKRAINIAN: "ukrajinský",
    GERMAN: "nemecký",
    SLOVAK: "slovenský",
    RUSSIAN: "ruský",
    ORDER_ACCEPTANCE: "prijatie objednávky",
    INTRODUCTION: "úvod",
    CALCULATOR: "kalkulačka",
    PROFESSIONAL_RELOCATION_SERVICES_IN_SWITZERLAND:
      "profesionálne sťahovacie služby vo Švajčiarsku",
    RELIABLE_LOADERS_EXPERIENCED_DRIVERS_AND_THE_BEST_PRICE_ON_THE_MARKET:
      "spoľahliví nakladači, skúsení vodiči a najlepšia cena na trhu",
    CALCULATE_THE_COST: "vypočítať náklady",
    SUPPORT: "podpora",
    RELIABLE_SERVICE: "spoľahlivý servis",
    WHY_CUSTOMERS_CHOOSE_US: "prečo si nás zákazníci vyberajú",
    FAVORABLE_PRICES: "priaznivé ceny",
    THE_BEST_PRICES_ON_THE_MARKET_WITHOUT_HIDDEN_FEES:
      "najlepšie ceny na trhu bez skrytých poplatkov",
    FAST_CAR_DELIVERY: "rýchle dodanie auta",
    TRANSPORT_WILL_ARRIVE_WITHIN_30_60_MINUTES: "doprava dorazí do 30-60 minút",
    EXPERIENCED_LOADERS: "skúsení nakladači",
    QUALIFIED_EMPLOYEES_WITH_EXTENSIVE_WORK_EXPERIENCE:
      "kvalifikovaní zamestnanci s rozsiahlymi pracovnými skúsenosťami",
    GUARANTEE_OF_PRESERVATION: "záruka zachovania",
    YOUR_BELONGINGS_ARE_SAFE_THROUGHOUT_THE_MOVE: "vaše veci sú počas sťahovania v bezpečí",
    OUR_SERVICES: "naše služby",
    WE_OFFER_A_FULL_RANGE_OF_SERVICES_FOR_MOVING_APARTMENTS_OFFICES_AND_INDUSTRIAL_FACILITIES:
      "ponúkame kompletné služby v oblasti sťahovania bytov, kancelárií a priemyselných budov",
    APARTMENT_MOVING: "sťahovanie bytu",
    OFFICE_RELOCATION: "sťahovanie kancelárie",
    INDUSTRIAL_RELOCATION: "priemyselné premiestnenie",
    MORE_DETAILS: "viac podrobností",
    MOVING_COST: "náklady na sťahovanie",
    FLEXIBLE_PRICING_SYSTEM_FOR_DIFFERENT_ORDERS: "flexibilný cenový systém pre rôzne objednávky",
    MINIMUM: "minimálna",
    FROM_PRICE: "od {{price}}",
    CARGO_GAZELLE: "nákladná gazela",
    TRUCK: "nákladné auto",
    T: "t",
    NUMBER_OF_LOADERS: "počet nakladačov",
    POPULAR: "obľúbený",
    PRICE_FOR_A_1_ROOM_APARTMENT: "cena za 1-izbový byt",
    PRICE_FOR_A_HOUSE_WITH_AN_AREA_OF_UP_TO_100_M: "cena za dom s rozlohou do 100 m²",
    PRICE_FOR_AN_OFFICE_WITH_AN_AREA_OF_UP_TO_50_M: "cena za kanceláriu s rozlohou do 50 m²",
    ORDER: "objednávka",
    [tk(Tk.ORDER, { plural: "one" })]: "objednávka",
    ...pluralForSlavic(Tk.ORDER, "objednávky"),
    [tk(Tk.ORDER, { partOfSpeech: "verb" })]: "objednať",
    COST_CALCULATOR: "kalkulačka nákladov",
    CALCULATE_THE_COST_OF_YOUR_MOVE: "vypočítajte si cenu vášho sťahovania",
    SELECT_SERVICES: "vyberte služby",
    TRANSPORTATION: "doprava",
    PACKING_THINGS: "balenie vecí",
    LOADING_UNLOADING: "nakladanie/vykladanie",
    VEHICLE: "vozidlo",
    YOUR_ORDER: "vaša objednávka",
    TOTAL: "spolu",
    OUR_CUSTOMERS_REVIEWS: "recenzie od našich zákazníkov",
    HOW_DO_WE_WORK: "ako pracujeme",
    PREPARATION: "príprava",
    MOVING: "pohybujúce sa",
    YOU_LEAVE_A_REQUEST_ON_THE_WEBSITE_OR_CALL_OUR_MANAGER_WILL_CONTACT_YOU_WITHIN_15_MINUTES:
      "zanechajte požiadavku na webovej stránke alebo zavolajte. Náš manažér vás bude kontaktovať do 15 minút",
    WE_CALCULATE_THE_COST_AGREE_ON_A_TIME_BRING_PACKING_MATERIALS_AND_PREPARE_THE_TEAM:
      "vypočítame cenu, dohodneme si čas, prinesieme baliaci materiál a pripravíme tím",
    OUR_SPECIALISTS_ARRIVE_AT_THE_APPOINTED_TIME_CAREFULLY_PACK_LOAD_AND_TRANSPORT_YOUR_BELONGINGS:
      "naši špecialisti prídu v dohodnutom čase, starostlivo zabalia, naložia a prepravia vaše veci",
    CONTACT_US: "kontaktujte nás",
    ADDRESS: "adresa",
    [tk(Tk.ADDRESS, { plural: "one" })]: "adresa",
    ...pluralForSlavic(Tk.ADDRESS, "adresy"),
    PHONE: "telefón",
    [tk(Tk.PHONE, { plural: "one" })]: "telefón",
    ...pluralForSlavic(Tk.PHONE, "telefóny"),
    EMAIL: "e-mail",
    [tk(Tk.EMAIL, { case_: "genitive" })]: "e-mailu",
    WORK_SCHEDULE: "pracovný rozvrh",
    SOCIAL_NETWORKS: "sociálne siete",
    WRITE_TO_US: "napíšte nám",
    REQUEST_SUBJECT: "predmet žiadosti",
    I_D_LIKE_TO_ORDER: "Chcel by som si objednať",
    QUESTIONS_ABOUT_SERVICES: "otázky týkajúce sa služieb",
    OTHER: "iné",
    MESSAGE: "správa",
    SEND: "poslať",
    CONVENIENT_FAST_RELIABLE: "pohodlné, rýchle, spoľahlivé",
    ALL_RIGHTS_RESERVED: "všetky práva vyhradené",
    THERE_WAS_AN_ERROR_LOADING_DATA: "pri načítavaní údajov sa vyskytla chyba",
    TRY_AGAIN: "skús to znova",
    ORDER_A_MOVE: "objednať sťahovanie",
    CONTACT_PERSON: "kontaktná osoba",
    FULL_NAME: "celé meno",
    CITY: "mesto",
    FLOOR: "poschodie",
    IS_THERE_AN_ELEVATOR: "je tam výťah",
    DESCRIPTION_OF_CARGO: "popis nákladu",
    FROM_WHERE: "odkiaľ",
    TO: "kam",
    SEND_AN_APPLICATION: "poslať žiadosť",
    DOES_NOT_MATCH_FORMAT: "nezodpovedá formátu {{format}}",
    NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED: "nedostatok znakov, je potrebný aspoň {{count}}",
    [tk(Tk.NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED, { plural: "one" })]:
      "nedostatok znakov, je potrebný aspoň {{count}}",
    ...pluralForSlavic(
      Tk.NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED,
      "nedostatok znakov, potrebné sú aspoň {{count}}",
    ),
    WHAT_IS_INCLUDED_IN_THE_SERVICE: "čo je zahrnuté v cene služby",
    NO_INFORMATION_PROVIDED_AT_THIS_TIME: "v súčasnosti nie sú poskytnuté žiadne informácie",
    MUST_BE_A_NUMBER: "musí byť číslo",
    MUST_BE_GREATER_THAN_N: "musí byť väčšie ako {{count}}",
    MUST_BE_AT_LEAST_N: "musí byť aspoň {{count}}",
    FIELD_CANNOT_BE_EMPTY: "pole nemôže byť prázdne",
    FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS: "pole musí obsahovať aspoň {{count}} znak",
    [tk(Tk.FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS, { plural: "one" })]:
      "pole musí obsahovať aspoň {{count}} znak",
    [tk(Tk.FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS, { plural: "few" })]:
      "pole musí obsahovať aspoň {{count}} znaky",
    [tk(Tk.FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS, { plural: "other" })]:
      "pole musí obsahovať aspoň {{count}} znakov",
    FIELD_MUST_MATCH_FORMAT: "pole musí zodpovedať formátu {{format}}",
    FIELD_MUST_CONTAIN_A_NUMBER: "pole musí obsahovať číslo",
    VALUE_MUST_BE_GREATER_THAN_N: "hodnota musí byť väčšia ako {{count}}",
    MINIMUM_VALUE_IS_N: "minimálna hodnota je {{count}}",
    FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER: "pole nesmie obsahovať viac ako {{count}} znak",
    [tk(Tk.FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER, { plural: "one" })]:
      "pole nesmie obsahovať viac ako {{count}} znak",
    [tk(Tk.FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER, { plural: "few" })]:
      "pole nesmie obsahovať viac ako {{count}} znaky",
    [tk(Tk.FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER, { plural: "other" })]:
      "pole nesmie obsahovať viac ako {{count}} znakov",
    VALUE_MUST_BE_LESS_THAN_N: "hodnota musí byť menšia ako {{count}}",
    MAXIMUM_VALUE_IS_N: "maximálna hodnota je {{count}}",
    PICK_A_DATE: "vyberte si dátum",
    HOW_DID_YOU_HEAR_ABOUT_US: "ako ste sa o nás dozvedeli",
    PLEASE_TELL_US_HOW_YOU_FOUND_OUT_ABOUT_US: "povedzte nám, prosím, ako ste sa o nás dozvedeli",
    WEB_SEARCH: "vyhľadávanie na webe",
    FRIEND_RECOMMENDATIONS: "odporúčania od priateľov",
    SOCIAL_MEDIA: "sociálne médiá",
    ADVERTISING: "reklama",
    GENDER: "pohlavie",
    MALE: "mužské",
    FEMALE: "ženské",
    UNDETERMINED: "neurčené",
    POSTAL_CODE: "poštové smerovacie číslo",
    BUILDING_TYPE: "typ budovy",
    PRIVATE_HOUSE: "súkromný dom",
    APARTMENT: "byt",
    OFFICE: "kancelária",
    AREA: "plocha",
    M: "m",
    NUMBER_OF_ROOMS: "počet izieb",
    IS_THERE_AN_ATTIC: "je tam podkrovie",
    IS_THERE_A_BASEMENT: "je tam suterén",
    PLANNED_MOVING_DATE: "plánovaný dátum sťahovania",
    SELECTED_SERVICES: "vybrané služby",
    MENU: "menu",
    DASHBOARD: "palubná doska",
    DOCUMENTATION: "dokumentácia",
    ADMINISTRATOR: "správca",
    A: "a",
    MY_PROFILE: "môj profil",
    ORDER_MANAGEMENT: "správa objednávok",
    SERVICE_MANAGEMENT: "správa služieb",
    USER_MANAGEMENT: "správa používateľov",
    NEW: "nový",
    COMPLETED: "dokončené",
    REVENUE: "príjmy",
    SINCE_YESTERDAY: "od včerajška",
    LATEST_ORDERS: "najnovšie objednávky",
    SHOW_ALL: "zobraziť všetko",
    ID: "id",
    CLIENT: "klient",
    DATE: "dátum",
    SUM: "súčet",
    STATUS: "stav",
    IN_PROGRESS: "prebieha",
    ASSIGNED: "pridelené",
    CANCELLED: "zrušené",
    ANNUAL_REVENUE: "ročný príjem",
    ADD_ORDER: "pridať objednávku",
    FILTER: "filter",
    WITH_ELEVATOR: "s výťahom",
    WITHOUT_ELEVATOR: "bez výťahu",
    EDIT: "upraviť",
    DELETE: "vymazať",
    YES: "áno",
    NO: "nie",
    ADD_A_SERVICE: "pridať službu",
    NAME: "meno",
    CATEGORY: "kategória",
    [tk(Tk.CATEGORY, { plural: "one" })]: "kategória",
    ...pluralForSlavic(Tk.CATEGORY, "kategórie"),
    PRICE: "cena",
    ACTIVE: "aktívny",
    INACTIVE: "neaktívny",
    ADD_USER: "pridať používateľa",
    EMPLOYEE: "zamestnanec",
    USER: "používateľ",
    [tk(Tk.USER, { plural: "one" })]: "používateľ",
    ...pluralForSlavic(Tk.USER, "používatelia"),
    ROLE: "rola",
    [tk(Tk.ROLE, { plural: "one" })]: "rola",
    ...pluralForSlavic(Tk.ROLE, "roly"),
    VIEW: "pohľad",
    ORDER_INFORMATION: "informácie o objednávke",
    CREATION_DATE: "dátum vytvorenia",
    TOTAL_COST: "celkové náklady",
    QUANTITY: "množstvo",
    INFORMATION_NOT_PROVIDED: "informácie neboli poskytnuté",
    CHANGE_STATUS: "zmeniť stav",
    ACTIONS: "akcie",
    PRINT: "tlačiť",
    STATUS_SUCCESSFULLY_CHANGED: "stav sa úspešne zmenil",
    FAILED_TO_CHANGE_STATUS: "nepodarilo sa zmeniť stav",
    THIS_ORDER_WAS_NOT_FOUND: "táto objednávka sa nenašla",
    SERVICE_CATEGORY_MANAGEMENT: "riadenie kategórií služieb",
    DESCRIPTION: "popis",
    ADD_CATEGORY: "pridať kategóriu",
    THIS_ACTION_CANNOT_BE_UNDONE: "túto akciu nie je možné vrátiť späť",
    NO_RECORDS_FOUND_IN_THE_DATABASE: "v databáze sa nenašli žiadne záznamy",
    NUMBER: "číslo",
    SIZE: "veľkosť",
    CREATE: "vytvoriť",
    LANGUAGE: "jazyk",
    SELECT_THE_LANGUAGE_IN_WHICH_YOU_WANT_TO_PROVIDE_DATA_FOR_FILLING_IN:
      "vyberte jazyk, v ktorom chcete poskytnúť údaje na vyplnenie",
    SAVE: "uložiť",
    RESET: "resetovať",
    IMAGE: "obrázok",
    ADD: "pridať",
    HYPERLINK: "hypertextový odkaz",
    CHANGES_SAVED_SUCCESSFULLY: "zmeny boli úspešne uložené",
    FAILED_TO_SAVE_CHANGES: "nepodarilo sa uložiť zmeny",
    SERVICE: "služba",
    [tk(Tk.SERVICE, { plural: "one" })]: "služba",
    ...pluralForSlavic(Tk.SERVICE, "služby"),
    THE_DATE_MUST_NOT_BE_IN_THE_PAST: "dátum nesmie byť v minulosti",
    ORDER_REQUEST: "žiadosť o objednávku",
    PASSWORD: "heslo",
    ADMINISTRATIVE_PANEL: "administratívny panel",
    FORGOT_YOUR_PASSWORD: "zabudol si heslo",
    REMEMBER_ME: "pamätaj si ma",
    SIGN_IN: "prihlásiť sa",
    FAILED_TO_LOG_IN: "nepodarilo sa prihlásiť",
    AN_UNEXPECTED_ERROR_OCCURRED_PLEASE_TRY_AGAIN_LATER:
      "vyskytla sa neočakávaná chyba, skúste to znova neskôr",
    INCORRECT_EMAIL_ADDRESS_AND_OR_PASSWORD: "nesprávna e-mailová adresa a/alebo heslo",
    SIGN_OUT: "odhlásiť sa",
    FIRST_NAME: "krstné meno",
    LAST_NAME: "priezvisko",
    THIS_EMAIL_ADDRESS_IS_ALREADY_IN_USE_BY_ANOTHER_USER:
      "túto e-mailovú adresu už používa iný používateľ",
    SUBJECT: "predmet",
    BODY: "telo",
    SENDING_AN_EMAIL: "odoslanie e-mailu",
    EMAIL_SENT_SUCCESSFULLY: "e-mail bol úspešne odoslaný",
    SOME_OF_THE_SELECTED_ROLES_DO_NOT_EXIST: "niektoré z vybraných rolí neexistujú",
    INQUIRY: "požiadavka",
    [tk(Tk.INQUIRY, { plural: "one" })]: "požiadavka",
    ...pluralForSlavic(Tk.INQUIRY, "požiadavky"),
    FAILED_TO_LOAD_YOUR_DATA: "nepodarilo sa načítať vaše údaje",
    ACCESS_TO_THE_PAGE_IS_DENIED: "prístup na stránku je zamietnutý",
    ONLY_ADMINISTRATORS_HAVE_ACCESS_TO_THIS_PAGE: "k tejto stránke majú prístup iba administrátori",
    ONLY_ADMINISTRATORS_AND_EMPLOYEES_HAVE_ACCESS_TO_THIS_PAGE:
      "k tejto stránke majú prístup iba administrátori a zamestnanci",
    YOU_ARE_ALREADY_LOGGED_IN: "už ste prihlásený/á",
    AUTHENTICATION_SESSION_EXPIRED: "overovacia relácia vypršala",
    ORDERED_SERVICES: "objednané služby",
    THE_DATE_MUST_NOT_BE_EARLIER_THAN_THE_CURRENT_MOMENT:
      "dátum nesmie byť skorší ako aktuálny okamih",
    YOU_HAVE_NOT_SELECTED_ANY_SERVICES: "nevybrali ste žiadne služby",
    VALUE_MUST_MATCH_PHONE_NUMBER_FORMAT: "hodnota musí zodpovedať formátu telefónneho čísla",
    "ENTER_THE_VALUE_IN_INTERNATIONAL_PHONE_NUMBER_FORMAT_I_E_...":
      "zadajte hodnotu v medzinárodnom formáte telefónneho čísla, t. j. +, predvoľba krajiny a samotné telefónne číslo (bez medzier), napríklad: +41791234567",
    ACCOUNT_LOGIN: "prihlásenie do účtu",
    "PROFESSIONAL_ORGANIZATION_OF_MOVING_TO_FROM_...":
      "profesionálna organizácia sťahovania do/z bytu, kancelárie alebo súkromného domu vo Švajčiarsku. Rýchle, bezpečné a bezproblémové. Naplánujte si sťahovanie s nami",
    "MOVING_IN_SWITZERLAND_APARTMENT_MOVING_OFFICE...":
      "sťahovanie vo Švajčiarsku, sťahovanie bytov, sťahovanie kancelárií, sťahovanie súkromných domov, sťahovanie bytov, preprava nábytku vo Švajčiarsku, sťahovacie služby",
    INQUIRY_MANAGEMENT: "riadenie dopytov",
    RESOLVED: "vyriešený",
    ADMINISTRATOR_COMMENT: "komentár administrátora",
    RESOLVE: "riešiť",
    INQUIRY_RESOLUTION: "riešenie požiadavky",
    REVIEW_MANAGEMENT: "riadenie recenzií",
    RATING: "hodnotenie",
    PROS: "výhody",
    CONS: "nevýhody",
    TEXT: "text",
    REVIEW: "recenzia",
    [tk(Tk.REVIEW, { plural: "one" })]: "recenzia",
    ...pluralForSlavic(Tk.REVIEW, "recenzie"),
    FAILED_TO_OPEN_PRINT_WINDOW: "nepodarilo sa otvoriť okno tlače",
    NEW_ORDER: "nová objednávka",
    NEW_INQUIRY: "nová požiadavka",
    NEW_REVIEW: "nová recenzia",
    SOMETHING_HAPPENED: "niečo sa stalo",
    MARK_AS_READ: "označiť ako prečítané",
    FAILED_TO_MARK_NOTIFICATION_AS_READ: "označenie oznámenia ako prečítaného zlyhalo",
    MARK_ALL_AS_READ: "označiť všetko ako prečítané",
    FAILED_TO_MARK_ALL_NOTIFICATIONS_AS_READ:
      "nepodarilo sa označiť všetky upozornenia ako prečítané",
    NOTIFICATION: "oznámenie",
    ORDER_CREATION: "vytvorenie objednávky",
    SERVICE_CREATION: "tvorba služieb",
    CATEGORY_CREATION: "vytvorenie kategórie",
    USER_CREATION: "vytvorenie používateľa",
    ORDER_CREATED: "objednávka vytvorená",
    SERVICE_CREATED: "služba vytvorená",
    CATEGORY_CREATED: "kategória vytvorená",
    USER_CREATED: "používateľ vytvoril",
    INQUIRY_CREATED: "požiadavka vytvorená",
    REVIEW_CREATED: "recenzia vytvorená",
    ORDER_REQUEST_CREATED: "vytvorená požiadavka na objednávku",
    FAILED_TO_CREATE_ORDER: "nepodarilo sa vytvoriť objednávku",
    FAILED_TO_CREATE_SERVICE: "nepodarilo sa vytvoriť službu",
    FAILED_TO_CREATE_CATEGORY: "nepodarilo sa vytvoriť kategóriu",
    FAILED_TO_CREATE_USER: "nepodarilo sa vytvoriť používateľa",
    FAILED_TO_CREATE_INQUIRY: "nepodarilo sa vytvoriť požiadavku",
    FAILED_TO_CREATE_REVIEW: "nevytvorilo sa recenziu",
    FAILED_TO_CREATE_ORDER_REQUEST: "nepodarilo sa vytvoriť požiadavku na objednávku",
    ORDER_DELETED: "objednávka odstránená",
    SERVICE_DELETED: "služba odstránená",
    CATEGORY_DELETED: "kategória odstránená",
    USER_DELETED: "používateľ odstránený",
    REVIEW_DELETED: "recenzia odstránená",
    INQUIRY_DELETED: "požiadavka odstránená",
    FAILED_TO_DELETE_ORDER: "objednávku sa nepodarilo odstrániť",
    FAILED_TO_DELETE_SERVICE: "nepodarilo sa odstrániť službu",
    FAILED_TO_DELETE_CATEGORY: "kategóriu sa nepodarilo odstrániť",
    FAILED_TO_DELETE_USER: "nepodarilo sa odstrániť používateľa",
    FAILED_TO_DELETE_REVIEW: "recenziu sa nepodarilo odstrániť",
    FAILED_TO_DELETE_INQUIRY: "nepodarilo sa odstrániť požiadavku",
    ORDER_NOT_FOUND: "objednávka sa nenašla",
    SERVICE_NOT_FOUND: "služba sa nenašla",
    CATEGORY_NOT_FOUND: "kategória sa nenašla",
    USER_NOT_FOUND: "používateľ sa nenašiel",
    REVIEW_NOT_FOUND: "recenzia sa nenašla",
    INQUIRY_NOT_FOUND: "požiadavka nenájdená",
    NOTIFICATION_NOT_FOUND: "oznámenie sa nenašlo",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_ORDER: "Naozaj chcete odstrániť objednávku?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SERVICE: "Naozaj chcete odstrániť túto službu?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_CATEGORY: "Naozaj chcete odstrániť túto kategóriu?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_USER: "Naozaj chcete odstrániť používateľa?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_REVIEW: "Naozaj chcete odstrániť recenziu?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_INQUIRY: "Naozaj chcete odstrániť požiadavku?",
    ORDER_EDITING: "úprava objednávky",
    SERVICE_EDITING: "úprava služieb",
    CATEGORY_EDITING: "úprava kategórie",
    USER_EDITING: "úprava používateľa",
    REVIEW_EDITING: "úprava recenzií",
    INQUIRY_EDITING: "úprava požiadavky",
    EDITING_ORDERED_SERVICES: "úprava objednaných služieb",
    FAILED_TO_PRINT_ORDER: "nepodarilo sa vytlačiť objednávku",
    FAILED_TO_SEND_EMAIL: "nepodarilo sa odoslať e-mail",
    FAILED_TO_SIGN_OUT: "nepodarilo sa odhlásiť",
    CONTACT: "kontakt",
    [tk(Tk.CONTACT, { plural: "one" })]: "kontakt",
    ...pluralForSlavic(Tk.CONTACT, "kontakty"),
    [tk(Tk.CONTACT, { context: "infinitive" })]: "kontaktovať",
    YOU_HAVE_NO_NOTIFICATIONS: "nemáte žiadne upozornenia",
    NO_REVIEWS_YET: "zatiaľ žiadne recenzie",
    WRITE_A_REVIEW: "napísať recenziu",
    WRITING_A_REVIEW: "písanie recenzie",
    ORDER_ID: "ID objednávky",
    PAGE_NOT_FOUND: "stránka sa nenašla",
    "IT_LOOKS_LIKE_THE_PAGE_...":
      "Zdá sa, že stránka, ktorú hľadáte, sa presunula na novú adresu. Ale nebojte sa, pomôžeme vám nájsť cestu späť!",
    HOME: "domov",
    RETURN_TO_THE_MAIN_PAGE: "návrat na hlavnú stránku",
    CALCULATE: "vypočítať",
    CALCULATE_THE_COST_OF_MOVING: "vypočítať náklady na sťahovanie",
    GO_TO: "prejsť na",
    PERSONAL_DATA_UPDATED: "osobné údaje boli aktualizované",
    FAILED_TO_UPDATE_PERSONAL_DATA: "nepodarilo sa aktualizovať osobné údaje",
    ROLE_DATA_UPDATED: "údaje o role boli aktualizované",
    FAILED_TO_UPDATE_ROLE_DATA: "nepodarilo sa aktualizovať údaje o úlohe",
    PAID: "zaplatená",
    UNPAID: "nezaplatená",
    ONLY_IMAGES_IN_JPG_PNG_SVG_FORMATS_ARE_ACCEPTED:
      "Akceptované sú iba obrázky vo formátoch {{formats}}",
    FAILED_TO_SAVE_IMAGE: "nepodarilo sa uložiť obrázok",
    FAILED_TO_DELETE_PREVIOUS_IMAGE: "nepodarilo sa odstrániť predchádzajúci obrázok",
    ARE_YOU_SURE_YOU_WANT_TO_CLEAR_FORM_DATA: "Naozaj chcete odstrániť údaje formulára?",
    MAX: "max",
    REVIEW_DETAILS: "podrobnosti recenzie",
    ORDER_NUMBER: "číslo objednávky",
    "NO.": "č.",
    OPEN_NAVIGATION_MENU: "otvoriť navigačnú ponuku",
    CLOSE_NAVIGATION_MENU: "zatvoriť navigačnú ponuku",
    PLEASE_PROVIDE_THIS_INFORMATION_ONLY_IF_YOU_WOULD_LIKE_US_TO_CONTACT_YOU:
      "Prosím, poskytnite nám tieto informácie iba v prípade, že chcete, aby sme vás kontaktovali.",
    THIS_INFORMATION_WILL_NOT_BE_AVAILABLE_PUBLICLY: "Tieto informácie nebudú verejne dostupné.",
    OPTIONAL: "voliteľné",
    PLEASE_PROVIDE_AT_LEAST_ONE_CONTACT_INFORMATION: "uveďte aspoň jeden kontaktný údaj",
    ORDER_DETAILS: "podrobnosti objednávky",
    ORDER_SUMMARY: "súhrn objednávky",
    CUSTOMER_SUPPORT: "zákaznícka podpora",
    APPROVED: "schválené",
    REJECTED: "zamietnuté",
    APPROVE: "schváliť",
    DISAPPROVE: "neschvaľovať",
    REVIEW_SUCCESSFULLY_APPROVED: "recenzia bola úspešne schválená",
    FAILED_TO_APPROVE_REVIEW: "nepodarilo sa schváliť recenziu",
    MY_ORDERS: "moje objednávky",
    DELETE_ALL: "vymazať všetko",
    "THIS_IS_SIMPLY_A_LIST_OF_ORDERS...":
      "Toto je jednoducho zoznam objednávok uložených vo vašom zariadení, takže si môžete kedykoľvek zobraziť podrobné informácie o každej z nich.",
    "DELETING_A_SPECIFIC_OR_ALL_ORDERS...":
      "Odstránením niektorých alebo všetkých objednávok sa z vášho zariadenia odstránia iba príslušné údaje. Údaje uložené v databáze zostanú nedotknuté.",
    "IF_YOU_NEED_TO_CHANGE_ANY_INFORMATION...":
      "Ak potrebujete zmeniť akékoľvek informácie o vašej objednávke alebo ju zrušiť, kontaktujte nás.",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALL_ORDERS: "Naozaj chcete odstrániť všetky objednávky?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ORDER_N: "Naozaj chcete odstrániť objednávku č. {{number}}?",
    YOU_HAVEN_T_CREATED_ANY_ORDERS_YET: "zatiaľ ste nevytvorili žiadne objednávky",
    "YOUR_REVIEW_WILL_BE_PUBLISHED_AFTER...":
      "vaša recenzia bude zverejnená po overení administrátorom",
    CHANGE_PASSWORD: "zmeniť heslo",
    PASSWORD_CHANGE: "zmena hesla",
    CURRENT_PASSWORD: "aktuálne heslo",
    NEW_PASSWORD: "nové heslo",
    REPEAT_NEW_PASSWORD: "zopakujte nové heslo",
    PASSWORDS_DO_NOT_MATCH: "heslá sa nezhodujú",
    PASSWORD_CHANGED: "heslo zmenené",
    FAILED_TO_CHANGE_PASSWORD: "nepodarilo sa zmeniť heslo",
    CURRENT_PASSWORD_IS_INCORRECT: "aktuálne heslo je nesprávne",
    INSUFFICIENT_RIGHTS_TO_PERFORM_THIS_ACTION: "nedostatočné práva na vykonanie tejto akcie",
    CASH_PAYMENT_IS_POSSIBLE: "platba v hotovosti je možná",
    WE_HAVE_SPECIAL_OFFERS_FOR_SENIORS: "máme špeciálne ponuky pre seniorov",
    WE_PROVIDE_A_10_DISCOUNT_FOR_STUDENTS: "poskytujeme 10% zľavu pre študentov",
    ABOUT_US: "o nás",
    PASSWORD_RESET: "obnovenie hesla",
    "ENTER_THE_EMAIL_ADDRESS_ASSOCIATED_WITH_YOUR_ACCOUNT...":
      "zadajte e-mailovú adresu spojenú s vaším účtom a my vám pošleme e-mail s novým heslom",
    RESET_PASSWORD: "obnoviť heslo",
    PASSWORD_RESET_SUCCESSFUL: "obnovenie hesla úspešné",
    AN_EMAIL_WITH_A_NEW_PASSWORD_HAS_BEEN_SENT_TO_YOUR_ADDRESS:
      "na vašu adresu bol odoslaný e-mail s novým heslom",
    FAILED_TO_SEND_PASSWORD_RESET_REQUEST: "žiadosť o obnovenie hesla sa nepodarilo odoslať",
    AN_ACCOUNT_WITH_THE_SPECIFIED_EMAIL_ADDRESS_WAS_NOT_FOUND:
      "účet so zadanou e-mailovou adresou sa nenašiel",
    ABOUT_US_CHAPTER_1_TITLE: "VÁŠ DOMOV - NAŠA PRÁCA",
    ABOUT_US_CHAPTER_1_PARAGRAPH:
      "Zabezpečíme, aby vaše sťahovanie prebehlo hladko. Či už sa sťahujete do nového mesta, do svojho prvého domu alebo potrebujete viac priestoru s rodinou – <strong>my vám sťahovanie uľahčíme a predovšetkým zbavíme stresu</strong>.",
    ABOUT_US_CHAPTER_2_TITLE: "VAŠA SPOLOČNOSŤ JE NAŠA PRÁCA",
    ABOUT_US_CHAPTER_2_PARAGRAPH_1:
      "<strong>Sťahovanie so spoločnosťou môže byť veľkou výzvou</strong>.",
    ABOUT_US_CHAPTER_2_PARAGRAPH_2:
      "Preto je užitočné mať po svojom boku kompetentného a skúseného partnera. Špecializujeme sa na efektívne a minimálne narušujúce firemné sťahovanie. Vy sa sústreďte na svoje hlavné podnikanie a my sa postaráme o zvyšok.",
    ABOUT_US_CHAPTER_3_TITLE: "LIKVIDÁCIE",
    ABOUT_US_CHAPTER_3_PARAGRAPH_1: "<strong>Uvoľnite priestor bez stresu</strong>.",
    ABOUT_US_CHAPTER_3_PARAGRAPH_2:
      "Starý nábytok, elektrospotrebiče alebo pokazené veci? Čohokoľvek sa potrebujete zbaviť, postaráme sa o to <strong>ekologicky a profesionálne</strong>. Či už po sťahovaní, uprataní domu alebo preto, že potrebujete viac miesta – postaráme sa o to, aby bolo všetko správne zlikvidované.",
    ABOUT_US_CHAPTER_4_TITLE: "O HEGI UMZÜGE",
    ABOUT_US_CHAPTER_4_PARAGRAPH_1:
      "Sme mladý, energický tím, ktorý sa snaží stať spoľahlivým partnerom v oblasti sťahovania. Hoci sme boli založení nedávno, máme bohaté skúsenosti so spoluprácou s poprednými spoločnosťami v tomto odvetví. Vieme, ako zorganizovať sťahovanie spôsobom, ktorý je pre našich klientov rýchly, bezpečný a bezstresový.",
    ABOUT_US_CHAPTER_4_PARAGRAPH_2:
      "Založením vlastnej spoločnosti sme spojili pokročilé skúsenosti a nápady, aby sme naše služby posunuli na novú úroveň. Naším cieľom nie je len sťahovať veci, ale dať ľuďom istotu a bezpečie v kľúčovej fáze ich života. Rastieme, učíme sa a zlepšujeme sa každý deň – v prospech tých, ktorí nám zverujú svoje sťahovanie.",
    SHOW_MY_ORDERS: "ukázať moje objednávky",
    HIDE_MY_ORDERS: "skryť moje rozkazy",
    QR_CODE_TO_GO_TO_THIS_SITE: "QR kód pre prechod na túto stránku",
    ALL_SERVICES_BELONGING_TO_THIS_CATEGORY_WILL_BE_DELETED:
      "všetky služby patriace do tejto kategórie budú odstránené",
    THE_ORDER_CANNOT_BE_UPDATED_BECAUSE_IT_HAS_ALREADY_BEEN_FULFILLED:
      "objednávku nie je možné aktualizovať, pretože už bola vybavená",
    CHANGE_OF_STATUS: "zmena stavu",
    THE_ORDER_STATUS_IS_COMPLETED_ARE_YOU_SURE_YOU_WANT_TO_CHANGE_IT_TO_NEW:
      "Stav objednávky je „{{current}}“. Naozaj ho chcete zmeniť na „{{new}}“?",
    CHANGE_PAYMENT_STATUS: "zmeniť stav platby",
    PAYMENT_STATUS_CHANGE: "zmena stavu platby",
    PAYMENT_STATUS_CHANGED: "stav platby sa zmenil",
    FAILED_TO_CHANGE_PAYMENT_STATUS: "nepodarilo sa zmeniť stav platby",
    MOST_LIKELY_IT_WAS_DELETED: "s najväčšou pravdepodobnosťou to bolo vymazané",
    SETTINGS: "nastavenia",
    CLOSE: "zatvoriť",
    CONSENT_MODAL_TITLE: "používame súbory cookie",
    CONSENT_MODAL_DESCRIPTION:
      "Na prevádzku našej webovej stránky a na zobrazovanie a analýzu reklám prostredníctvom služby Google Ads používame súbory cookie. Vždy sa používajú nevyhnutné súbory cookie. Všetky ostatné súbory cookie sa používajú iba s vaším súhlasom. Môžete prijať všetky súbory cookie, odmietnuť voliteľné alebo prispôsobiť svoje preferencie.",
    CONSENT_MODAL_ACCEPT_ALL: "prijať všetky",
    CONSENT_MODAL_ACCEPT_NECESSARY: "prijímať iba nevyhnutné",
    CONSENT_PREFERENCES_MODAL_TITLE: "nastavenia súborov cookie",
    CONSENT_PREFERENCES_MODAL_SAVE_PREFERENCES: "prijať",
    CONSENT_PREFERENCES_MODAL_SERVICE: "služba(y)",
    CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_TITLE: "nevyhnutné",
    CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_DESCRIPTION:
      "Tieto súbory cookie sú nevyhnutné na správne fungovanie webovej stránky, napríklad na autentifikáciu používateľov.",
    CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_TITLE: "analytika",
    CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_DESCRIPTION:
      "Súbory cookie používané na analytiku pomáhajú zhromažďovať údaje, ktoré službám umožňujú pochopiť, ako používatelia interagujú s konkrétnou službou.",
    CONSENT_PREFERENCES_MODAL_SERVICE_ANALYTICS_STORAGE:
      "Umožňuje ukladanie údajov (ako sú súbory cookie) súvisiacich s analytikou, ako je napríklad trvanie vašej návštevy.",
    CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_TITLE: "reklama",
    CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_DESCRIPTION:
      "Google používa súbory cookie na reklamné účely vrátane zobrazovania a poskytovania reklám, personalizácie reklám, obmedzenia počtu zobrazení reklamy, vypnutia reklám, ktoré si neželáte vidieť, a merania účinnosti reklamy.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_STORAGE:
      "Umožňuje ukladanie údajov (napríklad súborov cookie) súvisiacich s reklamou.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_USER_DATA:
      "Umožňuje odosielanie používateľských údajov súvisiacich s reklamou spoločnosti Google.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_PERSONALIZATION:
      "Umožňuje používanie údajov na personalizovanú reklamu.",
    CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_TITLE: "funkčnosť",
    CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_DESCRIPTION:
      "Funkčné súbory cookie umožňujú používateľom interagovať so službou alebo webovou stránkou a využívať funkcie, ktoré sú pre danú službu nevyhnutné.",
    CONSENT_PREFERENCES_MODAL_SERVICE_FUNCTIONALITY_STORAGE:
      "Umožňuje ukladanie údajov podporujúcich funkčnosť webovej stránky alebo aplikácie, napríklad jazykové nastavenia.",
    CONSENT_PREFERENCES_MODAL_SERVICE_PERSONALIZATION_STORAGE:
      "Umožňuje ukladanie údajov súvisiacich s personalizáciou, napríklad odporúčaní.",
    CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_TITLE: "bezpečnosť",
    CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_DESCRIPTION:
      "Súbory cookie používané na bezpečnostné účely, napríklad na autentifikáciu používateľov, predchádzanie podvodom a ochranu používateľov pri používaní služby.",
    CONSENT_PREFERENCES_MODAL_SERVICE_SECURITY_STORAGE:
      "Umožňuje ukladanie údajov súvisiacich s bezpečnosťou, napríklad na autentifikáciu, predchádzanie podvodom a ďalšie funkcie ochrany používateľov.",
    THE_PAGE_LANGUAGE_HAS_CHANGED_BUT_THE_CONTENTS:
      "Jazyk stránky sa zmenil, ale obsah dialógového okna súborov cookie sa aktualizuje až po opätovnom načítaní stránky.",
    IF_YOU_ARE_NOT_INTERESTED_IN_THE_CONTENTS:
      "Ak vás obsah dialógového okna súborov cookie nezaujíma, môžete túto správu ignorovať.",
    RELOAD_PAGE: "znova načítať stránku",
    CONSENT_SUMMARY_TITLE: "stav súhlasu so spracovaním údajov",
    CONSENT_SUMMARY_DESCRIPTION:
      "Stručný prehľad vášho aktuálneho stavu súhlasu. Podrobné informácie sú dostupné v nastaveniach.",
    CONSENT_ID: "ID súhlasu",
    LAST_MODIFIED: "naposledy zmenené",
    CONSENT_SUMMARY_ALLOWED: "povolené",
    CONSENT_SUMMARY_PARTIALLY_ALLOWED: "čiastočne povolené",
    CONSENT_SUMMARY_BLOCKED: "blokované",
  } satisfies Record<Tk, string>,
} satisfies ResourceLanguage;

export { RESOURCES };
